import MainMaterial from "./index.vue";

export default {
  path: "material",
  name: "MainMaterial",
  component: MainMaterial,
  meta: {
    label: "素材管理",
  },
};
